import { useState } from "react";
import { format, parseISO } from "date-fns";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Button } from "./ui/button";
import { CalendarBlank } from "@phosphor-icons/react";

/**
 * DatePicker — wraps shadcn Calendar in a Popover, returning ISO YYYY-MM-DD strings.
 * value: "YYYY-MM-DD" | "" — required
 * onChange: (string) => void — required
 */
export default function DatePicker({ value, onChange, placeholder = "Pick a date", className = "", testId }) {
  const [open, setOpen] = useState(false);
  const date = value ? parseISO(value) : undefined;
  const display = date ? format(date, "MMM d, yyyy") : placeholder;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          className={`w-full justify-start text-left font-normal ${!date ? "text-stone-400" : ""} ${className}`}
          data-testid={testId}
        >
          <CalendarBlank size={14} weight="duotone" className="mr-2" />
          {display}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={date}
          onSelect={(d) => {
            if (d) {
              onChange(format(d, "yyyy-MM-dd"));
              setOpen(false);
            }
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
